import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AppEntityTimestampDict } from '@nk/data-entities-lib';
import { filter } from 'rxjs/operators';
import { AppEntityTimestampEntity } from '@nk/data-entities-lib';
import { ApplicationApiClient } from '@nk/api-client-lib';

@Injectable({
  providedIn: 'root',
})
export class EntityUpdateTimestampService {
  private _timestamps = new BehaviorSubject<AppEntityTimestampDict>(null);
  public timestamps$ = this._timestamps.asObservable().pipe(filter((timestamps) => !!timestamps));

  constructor(private _api: ApplicationApiClient) {
    this._fetchEntityUpdateTimestamp().subscribe((data) => {
      const result = data.reduce((res: AppEntityTimestampDict, i) => {
        res[i.entity_key] = i.latest_timestamp;
        return res;
      }, {});
      this._timestamps.next(result);
    });
  }

  private _fetchEntityUpdateTimestamp(): Observable<AppEntityTimestampEntity[]> {
    return this._api.get<AppEntityTimestampEntity[]>(`app-entity-timestamp`, {}, null);
  }
}
